import React, { useEffect, useState } from 'react';
import '../Accordian/Accordian.scss'
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/fancy-example.css';
import { Markup } from 'interweave';

export interface IAccordian {
    heading: string;
    content: string;
    allowMultipleExpanded: boolean;
    allowZeroExpanded: boolean;
}

const Accordian: React.FC<IAccordian> = (props) => {

    let [header, setHeader] = useState<string>();
    let [content, setContent] = useState<string>();

    useEffect(() => {
        setHeader(props.heading);
        setContent(props.content);
    }, [])


   return (

        <div>
            { content && header &&
                <Accordion allowMultipleExpanded={props.allowMultipleExpanded} allowZeroExpanded={props.allowZeroExpanded}>
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                <div className="accordion-header"> {header} </div>
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <Markup content={content} />
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            }
        </div>
    );
}

export default Accordian;